import { TreetopPropertiesProvider } from 'shared/util-common';

export function getOrganisationImage(organisationId: string): string {
  return TreetopPropertiesProvider.properties.baseUrl + 'api/attachments/redirect?path=logos/' + organisationId.toLowerCase() + '.png';
}

export function getSmallOrganisationImage(organisationId: string): string {
  return (
    TreetopPropertiesProvider.properties.baseUrl + 'api/attachments/redirect?path=logos/' + organisationId.toLowerCase() + '_small.png'
  );
}
